import * as React from "react";
import styles from "../components/LeftNavigation/DesignerControls/BasicControls.module.css";

function SvgDeleteWhiteIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <defs></defs>
      <g className={styles.deleteWhiteIconA} transform="translate(757 -228)">
        <rect
          className={styles.deleteWhiteIconB}
          width="16"
          height="16"
          transform="translate(-757 228)"
        />
        <g transform="translate(-754 230)">
          <path
            className={styles.deleteWhiteIconC}
            style={props.style}
            onClick={props?.onClick}
            d="M8.333,12H1.667a.8.8,0,0,1-.833-.858V2.571H0V1.714H10v.857H9.167v8.571A.8.8,0,0,1,8.333,12ZM1.667,2.571v8.571H8.333V2.571Zm5,6.858H5.834V4.286h.833V9.428Zm-2.5,0H3.334V4.286h.833V9.428ZM6.667.857H3.333V0H6.667V.856Z"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgDeleteWhiteIcon;
